// Shared Type / Language options for the Email Templates screens.
// Document Request / Rejected / Accepted are the non-chasing DMS emails; the
// backend picks them by type + language (en / es).

export const CHASING_TYPE = "document_chasing";

export const emailTemplateTypeOptions = [
  { name: "Document Chasing", value: CHASING_TYPE },
  { name: "Document Request", value: "document_request" },
  { name: "Document Rejected", value: "document_rejected" },
  { name: "Document Accepted", value: "document_accepted" },
];

// Non-chasing DMS email types. Every other type (incl. existing chasing
// templates) is treated as chasing: no language, chasing placeholders.
export const NON_CHASING_TYPES = [
  "document_request",
  "document_rejected",
  "document_accepted",
];

export const isChasingTemplateType = (type) =>
  !NON_CHASING_TYPES.includes(type);

// Type options for the form; an existing record's type that is not in the list
// is kept as an option so editing never changes or blanks it.
export const getEmailTemplateTypeOptions = (currentType) =>
  !currentType ||
  emailTemplateTypeOptions.some((option) => option.value === currentType)
    ? emailTemplateTypeOptions
    : [...emailTemplateTypeOptions, { name: currentType, value: currentType }];

export const emailTemplateLanguageOptions = [
  { name: "English", value: "en" },
  { name: "Spanish", value: "es" },
];

export const getEmailTemplateTypeLabel = (type) =>
  emailTemplateTypeOptions.find((option) => option.value === type)?.name ||
  type;

export const CHASING_PLACEHOLDERS_HELP =
  "Available placeholders: {{ClientName}}, {{RequestedDocumentCount}}, {{ReceivedDocumentCount}}, {{PendingDocumentCount}}, {{PendingDocuments}}, {{LastRequestDate}}, {{LastReceivedDate}}";

export const NON_CHASING_PLACEHOLDERS_HELP =
  "Available variables: $contact_name, $case_case_number, $allDocumentNames, $document_title, $document_rejection_reason, $cpLink";
